import { gql } from '@apollo/client';

export const MY_FEED_MODE = gql`
  query myFeedMode {
    myFeedMode
  }
`;
